<template>
	<vForm :label-width="90" :model="formdata" inline>
		<!-- <vFormItem :label="$t('fbb.fedex.soucessystem',{defaultValue:'来源系统'})" prop="system" :rules="required" style="width:92%">
			<vSelect v-model="formdata.system" filterable>
				<vOption v-for="item in getSystemList" :value="item.value" :key="item.value">{{item.label}}</vOption>
			</vSelect>
		</vFormItem> -->
		<vFormItem :label="$t('fbb.alloment.carrier_code',{defaultValue:'承运商'})" prop="carrierCodeStatus" :rules="required" style="width:92%">
			<vSelect v-model="formdata.carrierCodeStatus" filterable>
				<vOption v-for="item in getCarrierCode" :value="item.value" :key="item.value">{{item.label}}</vOption>
			</vSelect>
		</vFormItem>
		<compUpload
			v-bind="getFileProps"
			@on-close="close"
			@on-success="success"
			:tip="$t('fbb.fedex.export_tip',{defaultValue:'导入模板为FedEx原始账单表'})"
		></compUpload>
	</vForm>
</template>
<script>
import { mapGetters } from "vuex";
export default {
	components: {
		compUpload: () => import("@components/templates/upload"),
	},
	data() {
		return {
			carrierCode: '',
			carrierServiceCode: '',
			labelValue: "",
			formdata: {
				// system: '0',
				carrierCodeStatus:'0',
			},
			required: [{
				required: true,
				message: this.$t('global.common.required',{defaultValue:'该信息不能为空,请填写'})
			}],

		}
	},
	computed: {
		getSystemList() {
			return [
				{ value: '0', label: this.$t('global.common.fbb',{defaultValue:'云仓'}) },
				{ value: '1', label: 'Bizark Cloud Shipping' },
			]
		},
		getCarrierCode() {
			return [
				{ value: 'FedEx', label: 'FedEx' },
				{ value: 'UPS', label: 'UPS' },
			]
		},
		getFileProps() {
			return {
				action: process.env.VUE_APP_APIURL_FBB + '/api/v2/carrierBillImport/import',
				name: "excelFile",
				data: {
					// sourceStatus: this.formdata.system,
					carrier:this.formdata.carrierCodeStatus
				},
			}
		},
	},
	methods: {
		success(res) {
			// console.log(343434343)
			this.$VMessage.success(res.message);
			this.close();
		},
		close() {
			// console.log(5656565656)
			this.$emit('on-close')
		}
	}
}
</script>
